<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-dialog customerEDIInfo"
    :style="$cookies.get('comp-id') === $cookies.get('ownr-id') ? 'width: 650px !important;' : ''"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        editedItem.action + ' ' + $t('lbl.filters.filter')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1">
      <v-card-text class="pa-0 pt-5">
        <v-row>
          <v-col cols="12">
            <v-form ref="form" class="dialog-content form-filter">
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.filters.filterName') }}
                  </v-label>
                  <v-text-field
                    ref="filterName"
                    v-model="editedItem.fltrNm"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage || editedItem.action === 'Edit'"
                    :class="[editedItem.action == 'Edit' ? 'name-input-disable' : '']"
                    heigth="30"
                    solo
                    @blur="validateFilterName()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.filters.filterType') }}
                  </v-label>
                  <v-autocomplete
                    v-model="editedItem.fltrTpCd"
                    :rules="[validationUtils.required]"
                    :items="filterType"
                    :disabled="!$auth.manage"
                    class="custom-selectbox"
                    height="30"
                    solo
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col lg="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.filters.filterPattern') }}
                  </v-label>
                  <v-text-field
                    v-if="editedItem.fltrTpCd != 'USERDATA'"
                    v-model="editedItem.srcPttn"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage"
                    solo
                    heigth="30"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="editedItem.fltrTpCd == 'USERDATA'">
                <v-col lg="6" class="pt-0">
                  <v-text-field
                    v-model="userData.key"
                    :maxlength="50"
                    solo
                    placeholder="Key"
                    :disabled="!$auth.manage"
                    :rules="editedItem.fltrTpCd === 'USERDATA' ? [validationUtils.required] : []"
                  ></v-text-field>
                </v-col>
                <v-col lg="6" class="pt-0 pl-0">
                  <v-text-field
                    v-model="userData.value"
                    :maxlength="50"
                    solo
                    placeholder="Value"
                    :disabled="!$auth.manage"
                    :rules="editedItem.fltrTpCd === 'USERDATA' ? [validationUtils.required] : []"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn
                class="btn btn-popup-search btn-popup"
                color="primary"
                @click="onSave"
                :disabled="!$auth.manage"
              >
                {{ $t('btn.common.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <dialogWindow
        ref="messageDialog"
        size="max"
        :info="checkDialogTitle"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeMessageDialog()"
      ></dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  name: 'add-filter-dialog',
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    refeshList: Function,
    paramItem: Object,
  },
  data() {
    return {
      editedItem: {
        fltrNm: '',
        fltrTpCd: '',
        srcPttn: '',
        action: '',
      },
      userData: {
        key: '',
        value: '',
      },
      filterType: [],
      checkDialogTitle: '',
      checkDialogColor: 'warning',
      checkDialogInfo: '',
    };
  },
  methods: {
    validateFilterName() {
      const isDuplicate = this.filterList.some(
        (e) => e.fltrNm === this.editedItem.fltrNm && e.fltrId !== this.editedItem.fltrId
      );
      if (isDuplicate) {
        this.checkDialogInfo = this.$t('msg.filter.checkDuplicate');
        this.checkDialogColor = 'warning';
        this.$refs.messageDialog.dialog = true;
        this.editedItem.fltrNm = '';
        return false;
      }
      return true;
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.filterName.focus();
      }, 300);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    removeMessageDialog() {
      this.$refs.messageDialog.dialog = false;
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },

    async onSave() {
      let validResult = this.$refs.form.validate();
      if (!this.validateFilterName()) return;
      if (this.editedItem.fltrTpCd == 'USERDATA') {
        this.editedItem.srcPttn = this.userData.key + '|' + this.userData.value;
      }
      if (validResult) {
        if (this.editedItem.action == 'Edit') {
          this.editedItem.byProcSetup = false;
          this.$store
            .dispatch('editFilter', this.editedItem)
            .then(() => {
              this.refeshList();
              this.removeDialog({});
            })
            .catch((ex) => {
              this.checkDialogColor = 'error';
              this.checkDialogInfo = this.$t('msg.filter.errorSave');
              this.$refs.messageDialog.dialog = true;
            });
        } else {
          this.$store
            .dispatch('insertFilter', this.editedItem)
            .then(() => {
              this.refeshList(this.editedItem);
              this.removeDialog({});
            })
            .catch((ex) => {
              this.checkDialogColor = 'error';
              this.checkDialogInfo = this.$t('msg.filter.errorSave');
              this.$refs.messageDialog.dialog = true;
            });
        }
      }
      return validResult;
    },
  },
  created() {
    this.editedItem = this.paramItem;
    if (this.paramItem.action == 'Add' || this.paramItem.action == 'Copy') {
      this.setFocus();
    }

    this.editedItem = Object.assign({}, this.paramItem);
    if (this.paramItem.action == 'Copy') {
      this.editedItem.fltrNm = '';
      this.editedItem.fltrId = '';
    }
    this.$store.dispatch('getFilterSelectBoxList');

    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P05' }).then(() => {
      this.filterType = this.$store.getters['caascommon/comCdList'];
    });

    if (this.editedItem.fltrTpCd == 'USERDATA') {
      let data = this.editedItem.srcPttn.split('|');
      this.userData.key = data[0];
      this.userData.value = data[1];
    }
  },
  computed: {
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
  },
};
</script>

<style>
.dialogs .dialog-drag.modify-filter-dialog .dialog-body {
  padding-top: 30px !important;
  background-color: #25272e !important;
}
.dialog-body .button-col.action-col.flt-custom {
  background-color: #25272e !important;
}
.name-input-disabled {
  opacity: 0.6;
}
</style>
